export default "__VITE_ASSET__Cufl5cx3__"